
<template>
  <article class="-filter" v-show="show">
    <div class="-filter-content">
      <div class="-filter-panel">
        <div class="-filter-header">
          <div class="row d-md-none">
            <div class="col-12">
              <v-btn flat large icon color="primary" @click="hide()">
                <v-icon dark>keyboard_backspace</v-icon>
              </v-btn>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <v-text-field
              :label="placeholder"
              v-model="input"
              @input="typing = true"
              :append-icon="'close'"
              @click:append="input = ''">
              </v-text-field>
            </div>
            <div class="close-button d-none d-md-block">
              <v-btn flat large icon color="primary" @click="hide()">
                <v-icon dark>close</v-icon>
              </v-btn>
            </div>
          </div>
        </div>

        <div class="model-filter-list" v-if="loadingProcedimentosList">
          <div class="row">
            <div class="col-12">
              <div class="model-filter-status">Carregando...</div>
            </div>
          </div>
        </div>

        <div class="model-filter-list" v-else>
          <div class="row" v-if="data.length > 0">
            <div class="col-12">
              <div class="table-filter-wrap">
                <ul>
                  <li v-for="(item, index) in dataFiltered" :key="index">
                    <a @click="selected(item)">
                      <p><b>{{ item[properties[0]] }}</b></p>
                      <p v-if="item[properties[1]]">{{ item[properties[1]] }}</p>
                      <p v-if="item[properties[2]]">{{ item[properties[2]] }}</p>
                      <p v-if="item[properties[3]]">{{ item[properties[3]] }}</p>
                      <p v-if="item[properties[4]]">{{ item[properties[4]] }}</p>
                      <p v-if="item[properties[5]]">{{ item[properties[5]] }}</p>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="row" v-else>
            <div class="col-12">
              <div class="model-filter-status">Nenhum dado encontrado.</div>
            </div>
          </div>
        </div>

        <div class="-filter-footer" v-if="multiple">
          <v-layout row wrap>
            <v-flex xs12 text-right>
              <v-btn v-on:click="hide">Cancelar</v-btn>
              <v-btn v-on:click="ok">Ok</v-btn>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import _ from 'lodash'
import Fuse from 'fuse.js'

export default {
  props: {
    data: {
      type: Array,
      default: [],
    },
    loadingProcedimentosList: {
      type: Boolean,
    },
    keysToFilter: {
      type: Array,
      default: [],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    itemTitulo: {
      type: String,
    },
    itemSubtitulo: {
      type: String,
    },
    placeholder: {
      type: String,
      default: 'Buscar',
    },
    properties: {
      type: Array,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      typing: false,
      input: '',
      selecteds: [],
      dataFiltered: [],
    }
  },
  methods: {
    change(input) {
      this.loading = true
      this.typing = true

      setTimeout(() => {
        this.typing = false

        this.filter(input)
      }, 1000)
    },

    filter(input) {
      this.setInitialData()

      const fuseOptions = {
        tokenize: true,
        matchAllTokens: true,
        threshold: 0.0,
        location: 0,
        distance: 20,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        // keys: ["codigoUnico", "descricao"]
        keys: this.keysToFilter,
      }

      const fuse = new Fuse(this.dataFiltered, fuseOptions)
      const filterResult = fuse.search(input)

      this.dataFiltered = input ? filterResult : this.dataFiltered
    },

    hide() {
      this.$emit('close')
      this.input = ''
    },

    ok() {
      this.selecteds = []

      this.data.map((procedimento) => {
        if (procedimento._.selected) {
          this.selecteds.push(procedimento)
        }
      })

      this.$emit('selected', this.selecteds)
      this.hide()
    },

    addToSelectedsList(item, index) {
      if (this.data[index]._.selected) {
        this.data[index]._.selected = false
      } else {
        this.data[index]._.selected = true
      }
    },

    selected(item, index) {
      if (this.multiple) {
        this.addToSelectedsList(item, index)
      } else {
        this.$emit('selected', item)
        this.hide()
      }
    },

    setInitialData() {
      this.dataFiltered = this.data
    },

    toggleBodyOverflow() {
      const html = document.querySelector('html')
      const noOverflowClass = '-is-open'

      html.classList.toggle(noOverflowClass)
    },
  },
  mounted() {
    this.setInitialData()
  },
  watch: {
    show() {
      this.toggleBodyOverflow()
    },

    input: _.debounce(function () {
      this.typing = false

      this.filter(this.input)
    }, 300),

    data() {
      this.setInitialData()
    },
  },
}

</script>

<style lang="scss" scoped>
  .-filter {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    overflow: hidden;
    background: rgba(0, 0, 0, .7);
  }

  .-filter-content {
    max-width: 720px;
    margin: 0 auto;
    width: 100%;
    height: 100%;
    display: table;
    padding: 75px 50px;

    @media(max-width: 767px) {
      padding: 0;
    }
  }

  .-filter-panel {
    background-color: #FFF;
    padding: 0 0 7px;
    margin: 0 auto;
    display: table-cell;
    vertical-align: middle;
    border-radius: 4px;

    @media(max-width: 767px) {
      border-radius: 0
    }
  }

  .-filter-header {
    height: 10%;
    min-height: 70px;
    padding: 10px 15px;

    @media(max-width: 767px) {
      height: 20%;
      min-height: 114px;
    }
  }

  .model-filter-list {
    height: 85%;
    width: 100%;
    overflow-y: scroll;
    overflow-x: hidden;

    @media(max-width: 767px) {
      height: 80%;
    }
  }

  .-filter-footer {
    padding-top: 20px;
    height: 15%;
  }

  .table-filter-wrap {
    width: 100%;
  }

  .model-filter-list ul {
    padding-left: 0;
    width: 100%;
    height: 100%;
  }

  .model-filter-list ul li {
    border-top: 1px solid #EEE;
    border-bottom: 0;
    list-style: none;
  }

  .model-filter-list a {
    padding: 10px 20px;
    display: block;
  }

  .model-filter-list a:hover {
    background-color: #EEE;
    text-decoration: none;

    @media(max-width: 767px) {
      background-color: #FFF
    }
  }

  .model-filter-list ul li:last-child {
    border-bottom: 1px solid #EEE
  }

  .model-filter-status {
    font-size: 12px;
    padding: 0 20px;
    color: #666;
  }

  .close-button {
    padding: 0;
    position: relative;

    button {
      position: absolute;
      top: -60px;
      right: -40px;
    }
  }

  p {
    margin: 0
  }

  .selected {
    background-color: #e9f7fd
  }

</style>
